import { render, staticRenderFns } from "./detailEdit.vue?vue&type=template&id=1ebacbe5&"
import script from "./detailEdit.vue?vue&type=script&lang=js&"
export * from "./detailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports